import { render, staticRenderFns } from "./CountriesFooterList.vue?vue&type=template&id=51dc196d&"
import script from "./CountriesFooterList.vue?vue&type=script&lang=js&"
export * from "./CountriesFooterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports